module.exports = __webpack_public_path__ + "media/components/assets/images/watchingQnaImg-2b64d05d6b63104910e8bf3c4bfbcd53.png";